/* Nélya Paris — câblage de la page. La logique testable est dans nelya-core.js. */
(function () {
  'use strict';
  var C = window.NelyaCore;
  var root = document.documentElement;
  var isProduct = document.body.classList.contains('template-product');

  function readVariants() {
    var el = document.getElementById('nelya-variants');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }
  var variants = readVariants();

  /* Nom affiché d'une teinte (traduit dans les locales) ; la valeur interne reste « Brun » ou « Gris ». */
  function shadeName(t) {
    var s = window.nelyaShop && window.nelyaShop.shades;
    return (s && s[t]) || t;
  }

  /* Teinte : une seule valeur pour toute la page (visuels, cartes, libellés, formulaire, URL du produit). */
  function setTeinte(v, opts) {
    var t = C.normalizeTeinte(v);
    if (!t) return;
    root.setAttribute('data-teinte', t);
    document.querySelectorAll('input[data-teinte]').forEach(function (i) { i.checked = i.value === t; });
    document.querySelectorAll('[data-shade-name]').forEach(function (n) { n.textContent = shadeName(t); });
    document.querySelectorAll('.shade-img[data-for]').forEach(function (im) {
      if (im.getAttribute('data-for') === t) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true');
    });
    var variant = C.variantForTeinte(variants, t);
    if (!variant) return;
    // Chaque formulaire porte ses propres variantes (data-variant-brun / data-variant-gris).
    document.querySelectorAll('form.js-product-form').forEach(function (f) {
      var id = f.getAttribute('data-variant-' + t.toLowerCase());
      var input = f.querySelector('[data-variant-input]');
      if (id && input) input.value = id;
    });
    document.dispatchEvent(new CustomEvent('nelya:teinte', { detail: { teinte: t, variant: variant } }));
    // Avec le bloc bundle, l'adresse n'est pas modifiée : la variante commandée est dans le formulaire (nelya-bundle.js).
    if (isProduct && !document.querySelector('[data-lots]') && !(opts && opts.silent) && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }
  window.nelyaSetTeinte = setTeinte;

  /* Images différées (mannequin de l'autre teinte en couverture) : chargées après la page ou au choix de la teinte. */
  function loadDeferred() {
    document.querySelectorAll('img[data-deferred-src]').forEach(function (im) {
      if (im.hasAttribute('data-deferred-srcset')) im.setAttribute('srcset', im.getAttribute('data-deferred-srcset'));
      im.setAttribute('src', im.getAttribute('data-deferred-src'));
      im.removeAttribute('data-deferred-src'); im.removeAttribute('data-deferred-srcset');
    });
  }
  if (document.readyState === 'complete') setTimeout(loadDeferred, 1500);
  else window.addEventListener('load', function () { setTimeout(loadDeferred, 1500); });

  function initTeinte() {
    document.querySelectorAll('input[data-teinte]').forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) setTeinte(i.value); });
    });
    var variantId = isProduct ? new URL(window.location.href).searchParams.get('variant') : null;
    setTeinte(C.initialTeinte({ variantId: variantId, variants: variants }), { silent: true });
  }

  /* Liens vers la page produit (section « Le coffret » de l'accueil) : ils suivent la teinte choisie (?variant=).
     Le thème n'ajoute jamais rien au panier : l'achat se fait par le formulaire Releasit de la page produit. */
  function initProductLinks() {
    document.addEventListener('nelya:teinte', function (e) {
      document.querySelectorAll('[data-product-link]').forEach(function (a) {
        var box = a.closest('[data-variant-brun]');
        var id = box && box.getAttribute('data-variant-' + e.detail.teinte.toLowerCase());
        if (!id) return;
        var url = new URL(a.href, window.location.href);
        url.searchParams.set('variant', id);
        a.href = url.pathname + url.search + url.hash;
      });
    });
  }

  /* Avis : flèches du carrousel. */
  function initUgc() {
    var l = document.getElementById('ugc');
    if (!l) return;
    document.querySelectorAll('[data-ugc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = l.querySelector('.ugc__card');
        var w = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(l).columnGap || 0) : 320;
        l.scrollBy({ left: (b.getAttribute('data-ugc') === 'next' ? 1 : -1) * w, behavior: 'smooth' });
      });
    });
  }

  /* Menu mobile (burger) : ouvre/ferme la liste, Échap ferme et rend le focus. */
  function initBurger() {
    var header = document.querySelector('[data-header]');
    var btn = header && header.querySelector('[data-burger]');
    if (!btn) return;
    function set(open) {
      header.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(open ? 'data-label-close' : 'data-label-open'));
    }
    btn.setAttribute('data-label-open', btn.getAttribute('aria-label'));
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
    });
    header.querySelectorAll('.r3-links a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
  }

  /* Aide teinte : la réponse choisit la teinte et affiche le conseil. Échap la referme. Quand elle s'ouvre en panneau
     par-dessus les cartes (ordinateur, voir nelya-product.css), un clic en dehors ou le clavier qui la quitte la referme aussi. */
  function initHelper() {
    var helper = document.querySelector('details.helper');
    var out = document.querySelector('.helper__out');
    if (helper) {
      var panel = helper.querySelector('.helper__in');
      var floating = function () { return getComputedStyle(panel).position === 'absolute'; };
      document.addEventListener('click', function (e) { if (helper.open && !helper.contains(e.target) && floating()) helper.open = false; });
      document.addEventListener('keydown', function (e) {
        var f = document.activeElement;
        if (e.key !== 'Escape' || !helper.open || (f && f !== document.body && !helper.contains(f))) return;
        helper.open = false; helper.querySelector('summary').focus();
      });
      helper.addEventListener('focusout', function (e) {
        if (helper.open && e.relatedTarget && !helper.contains(e.relatedTarget) && floating()) helper.open = false;
      });
    }
    document.querySelectorAll('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-pick');
        setTeinte(v);
        document.querySelectorAll('[data-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
        if (out) { out.hidden = false; out.querySelector('[data-reco]').textContent = shadeName(v); }
      });
    });
  }

  /* Galerie : piste à défilement (glisser au doigt), miniatures, flèches, clavier, compteur, points.
     Seules les diapositives communes et celles de la teinte choisie sont montrées. */
  function initGallery() {
    var t = document.getElementById('g-track');
    if (!t) return;
    var all = [].slice.call(t.children);
    var thumbs = [].slice.call(document.querySelectorAll('.gallery__thumbs li'));
    var dots = [].slice.call(document.querySelectorAll('.gallery__dots i'));
    var n = document.getElementById('g-n'), total = document.getElementById('g-total');
    var visible = [], cur = -1, raf;
    function mark(i) {
      if (i === cur) return;
      cur = i; n.textContent = i + 1;
      visible.forEach(function (k, j) {
        thumbs[k].querySelector('button').setAttribute('aria-current', j === i ? 'true' : 'false');
        dots[k].classList.toggle('on', j === i);
      });
    }
    function filter(teinte) {
      visible = C.visibleSlides(all.map(function (s) { return s.getAttribute('data-slide-for') || ''; }), teinte);
      all.forEach(function (s, k) {
        var on = visible.indexOf(k) !== -1;
        s.hidden = !on; thumbs[k].hidden = !on; dots[k].hidden = !on;
      });
      total.textContent = visible.length;
      cur = -1; mark(Math.min(C.galleryIndex(t.scrollLeft, t.clientWidth, visible.length), visible.length - 1));
    }
    function go(i) {
      i = Math.max(0, Math.min(visible.length - 1, i));
      t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' });
    }
    t.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(C.galleryIndex(t.scrollLeft, t.clientWidth, visible.length)); });
    }, { passive: true });
    thumbs.forEach(function (li, k) {
      li.querySelector('button').addEventListener('click', function () { go(visible.indexOf(k)); });
    });
    document.querySelectorAll('[data-g]').forEach(function (b) {
      b.addEventListener('click', function () { go(cur + (b.getAttribute('data-g') === 'next' ? 1 : -1)); });
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    document.addEventListener('nelya:teinte', function (e) { filter(e.detail.teinte); });
    filter(root.getAttribute('data-teinte'));
  }

  /* Quantité : bornée de 1 à 10, total affiché sur les boutons d'achat. */
  function initQty() {
    var o = document.getElementById('qty');
    var input = document.querySelector('[data-qty-input]');
    var unitEl = document.querySelector('[data-unit]');
    if (!o || !input || !unitEl) return;
    var unit = Number(unitEl.getAttribute('data-unit'));
    input.value = 1; o.textContent = 1;
    function render() {
      var q = Number(input.value);
      document.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = C.formatMoney(unit * q); });
      document.querySelectorAll('[data-unit-price]').forEach(function (el) { el.textContent = C.formatMoney(unit); });
    }
    document.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = C.clampQty(Number(input.value) + parseInt(b.getAttribute('data-q'), 10));
        input.value = q; o.textContent = q;
        render();
      });
    });
    document.addEventListener('nelya:teinte', function (e) { unit = e.detail.variant.price; render(); });
  }

  /* Barre d'achat collante : visible tant que le bouton principal n'est pas entièrement à l'écran (passé au-dessus, ou
     encore en dessous quand les lots le repoussent sous la ligne de flottaison). */
  function initStickybuy() {
    var a = document.getElementById('addrow'), s = document.getElementById('stickybuy');
    if (!a || !s) return;
    var btn = s.querySelector('a, button'), last = null;
    function set(on) {
      if (on === last) return;
      last = on;
      s.classList.toggle('is-on', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    // L'observateur suit tout déplacement du bouton : défilement, lots, aide teinte, polices et images chargées après coup.
    // Un bouton non affiché (taille nulle) ne fait pas apparaître la barre.
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      set(e.boundingClientRect.height > 0 && e.intersectionRatio < 0.99);
    }, { threshold: [0, 0.99] }).observe(a);
  }

  initBurger();
  initGallery();
  initQty();
  initProductLinks();
  initTeinte();
  // Après l'initialisation : seul un vrai changement de teinte avance le chargement des images différées.
  document.addEventListener('nelya:teinte', loadDeferred);
  initUgc();
  initHelper();
  initStickybuy();
})();
